import { Pipe, PipeTransform } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';

@Pipe({
    name: 'stbyDateFromString',
})
export class DateFromStringPipe implements PipeTransform {
    transform(value: string): Dayjs {
        return dayjs(value);
    }
}
